import Template from "./template.jsx";

export default {
  element: <Template />,
  loader: async () => {
    return {};
  },
};
